import React from 'react';
import { CheckIcon } from 'lucide-react';
const includes = ['5 Módulos Maestros completos', 'Clases grabadas paso a paso', '4 Bonos exclusivos de regalo', 'Acceso inmediato en formato PDF'];
export function IncludesSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-193">
      <div className="max-w-3xl mx-auto" data-id="element-194">
        <div className="bg-brand-ice p-8 md:p-10 rounded-3xl border border-brand-secondary shadow-sm" data-id="element-195">
          <h2 className="text-2xl md:text-3xl font-black text-center text-brand-dark mb-8" data-id="element-196">
            Resumen de tu acceso:
          </h2>
          <ul className="space-y-5" data-id="element-197">
            {includes.map((item, index) => <li key={index} className="flex items-center gap-4" data-id="element-198">
                <div className="bg-brand-primary p-1.5 rounded-full flex-shrink-0" data-id="element-199">
                  <CheckIcon className="w-5 h-5 text-white" strokeWidth={3} data-id="element-200" />
                </div>
                <span className="text-xl font-bold text-gray-800" data-id="element-201">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}